import { ShipmentDto, ShipmentGroupDto, ShipmentItemDto, ShipmentStatus } from './shipment.dto';

export interface ShipmentVm {
  id: number;
  shipmentNumber: string;
  transport: string;
  plannedDate: string | null;
  status: ShipmentStatus;
  statusLabel: string;
  shippedAt: string | null;
  createdAt: string;
  groups: ShipmentGroupVm[];
}

export interface ShipmentGroupVm {
  clientOrderId: number;
  clientOrderNumber: string;
  clientName: string;
  items: ShipmentItemVm[];
}

export interface ShipmentItemVm {
  shipmentItemId: number;
  clientOrderItemId: number;
  name: string;
  unit: string;
  amount: number;
  orderedAmount: number;
  primaryPhotoAttachmentId: number | null;
}

// the two states a wysyłka has, as the list and the detail name them
export const SHIPMENT_STATUS_LABELS: Record<ShipmentStatus, string> = {
  [ShipmentStatus.planned]: 'Planowana',
  [ShipmentStatus.shipped]: 'Wysłana'
};

export function isPlanned(shipment: ShipmentVm): boolean {
  return shipment.status === ShipmentStatus.planned;
}

export function isEmpty(shipment: ShipmentVm): boolean {
  return shipment.groups.every(group => group.items.length === 0);
}

export namespace ShipmentVm {
  export function mapModelToViewModel(shipment: ShipmentDto): ShipmentVm {
    return {
      id: shipment.id,
      shipmentNumber: shipment.shipmentNumber,
      transport: shipment.transport,
      plannedDate: shipment.plannedDate,
      status: shipment.status,
      statusLabel: SHIPMENT_STATUS_LABELS[shipment.status],
      shippedAt: shipment.shippedAt,
      createdAt: shipment.createdAt,
      groups: shipment.groups.map(ShipmentGroupVm.mapModelToViewModel)
    };
  }
}

export namespace ShipmentGroupVm {
  export function mapModelToViewModel(group: ShipmentGroupDto): ShipmentGroupVm {
    return {
      clientOrderId: group.clientOrderId,
      clientOrderNumber: group.clientOrderNumber,
      clientName: group.clientName,
      items: group.items.map(ShipmentItemVm.mapModelToViewModel)
    };
  }
}

export namespace ShipmentItemVm {
  export function mapModelToViewModel(item: ShipmentItemDto): ShipmentItemVm {
    return {
      shipmentItemId: item.shipmentItemId,
      clientOrderItemId: item.clientOrderItemId,
      name: item.name,
      unit: item.unit,
      amount: item.amount,
      orderedAmount: item.orderedAmount,
      primaryPhotoAttachmentId: item.primaryPhotoAttachmentId ?? null
    };
  }
}
